import React from "react";

const NotFound = () => {
  return (
    <div className="ScrollHome d-flex ">
      <img
        src="https://www.myphukettravel.com/assets/front-end/images/404.gif"
        alt=""
      />
    </div>
  );
};

export default NotFound;
